import React from "react";
import { Link } from "react-router-dom";
import { Paths } from "./../../constants/UrlConstants";

const ClaimBackChemoOrRadiotherapy = {
  label: "What type of treatment are you claiming for?",
  option1: "chemotherapy",
  option2: "radiotherapy",
  notExistingClaim: (
    <React.Fragment>
      If you haven't yet discussed your treatment with us, please{" "}
      <Link className="hol-link" to={Paths.ContactUs}>
        call us
      </Link>
      . We’ll need to speak to you about your treatment plan before you send
      your cash benefit request.
    </React.Fragment>
  )
};

export default ClaimBackChemoOrRadiotherapy;
